import { render, staticRenderFns } from "./VehicleDisplay.vue?vue&type=template&id=46d5cefc&"
import script from "./VehicleDisplay.vue?vue&type=script&lang=ts&"
export * from "./VehicleDisplay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports